import { useEffect } from 'react';

// Fades `[data-reveal]` descendants of `rootRef` in as they scroll into view.
// The hidden state only applies once `tp-reveal-ready` is on the root, so
// content stays visible if IntersectionObserver is unavailable. Pass a
// `refreshKey` that changes when new reveal targets render (e.g. after data
// loads) so they get observed too.
const useReveal = (rootRef, refreshKey) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root || typeof IntersectionObserver === 'undefined') return undefined;

    root.classList.add('tp-reveal-ready');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    );

    root.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [rootRef, refreshKey]);
};

export default useReveal;
